// @flow

import React from 'react';
import { Link } from 'react-router-dom';

import { withPrefix } from '../../helpers';

type Props = {
  index: string,
  link?: string,
  text: string,
  onClick?: () => void
};

const withClass = withPrefix('c-SubHeading');

export const SubHeadingMenuItem = ({ index, link, text, onClick }: Props) =>
  link ? (
    <Link key={index} to={link}>
      <div className={withClass('__item')}>{text}</div>
    </Link>
  ) : (
    <div
      key={index}
      onClick={onClick}
      tabIndex={0}
      onKeyDown={(e: SyntheticKeyboardEvent<HTMLInputElement>) =>
        e.key === 'Enter' && onClick && onClick()
      }
    >
      <div className={withClass('__item')}>{text}</div>
    </div>
  );
